import React, {useEffect, useState} from "react";
import {CopyIcon} from "../utils/image";

const DefaultInputComponent = (props) => {
    const {type, keyName, pattern, title, placeholder, inputRef, disabled, defaultValue, onChangeInput, copyText} = props
    const [val, setVal] = useState()

    const setValHandler = (key, val) => {
        const value = !!val ? val : null
        !!onChangeInput && onChangeInput(key, value)
    }

    useEffect(() => {
        if (!!defaultValue) {
            setVal(defaultValue)
        } else {
            setVal('')
        }
    }, [defaultValue])

    return (
        <div
            className={`row items-center px-2 h-9 border border-placebo text-forged-steel rounded-lg ${disabled && 'bg-[#f6f6f6]'}`}>
            <input type={type} name={keyName} pattern={pattern} title={title}
                   className={"border-0 outline-0 px-3 w-full placeholder:italic"}
                   placeholder={placeholder}
                   defaultValue={val}
                   ref={inputRef}
                   disabled={disabled}
                   onKeyUp={(e) => setValHandler(keyName, e.target.value)}
            />
            {copyText &&
                <img className={'cursor-pointer'} src={CopyIcon} width={16} height={16} alt='copy' onClick={() => navigator.clipboard.writeText(val)}/>
            }
        </div>
    )
}

export default DefaultInputComponent
